import { render } from "./index.vue?vue&type=template&id=0586247d"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=0586247d&lang=scss"
script.render = render

export default script